import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

export const ChangeToPrototypeModal = ({ onConfirm, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal visible centered>
      <Dialog
        dialog={{
          heading: t(translations.campaigns_changeToPrototypeTitle),
          content: t(translations.campaigns_changeToPrototypeWarning),
          onClose,
          footer: (
            <>
              <Button label={t(translations.confirm)} colored onClick={onConfirm} testId="campaign-prototype-confirm" />
              <Button label={t(translations.cancel)} onClick={onClose} testId="campaign-prototype-cancel" />
            </>
          ),
        }}
      />
    </Modal>
  );
};
